import React from "react";
import { useTheme } from "@mui/material/styles";
import { LineChart } from "@mui/x-charts";

import {
  defaultColorPalette,
  getCartesianChartData,
  cartesianChartStyling,
} from "./utils";

interface LineGraphProps {
  children?: React.ReactNode;
  content: Array<{ [key: string]: any }>;
  xAxisKey: string;
  yAxisKey?: string;
}

const LineGraph: React.FC<LineGraphProps> = ({
  content,
  xAxisKey,
  yAxisKey,
}) => {
  const theme = useTheme();
  const colorPalette = [theme.palette.primary.main, ...defaultColorPalette];

  const { xLabel, yLabel, abbreviatedContent, series } = getCartesianChartData(
    content,
    xAxisKey,
    colorPalette,
    yAxisKey,
  );

  return (
    <LineChart
      dataset={abbreviatedContent}
      xAxis={[{ dataKey: xAxisKey, scaleType: "band", label: xLabel }]}
      series={series}
      yAxis={[{ label: yLabel }]}
      height={300}
      width={700}
      margin={{ left: 100, top: 30, bottom: 50 }}
      grid={{ vertical: true, horizontal: true }}
      {...cartesianChartStyling}
    />
  );
};

export const validateLineGraph = (data: any[], xAxis?: string): boolean => {
  if (!Array.isArray(data) || data.length === 0) return false;
  if (typeof data[0] !== "object") return false;
  const keys = Object.keys(data[0]);
  return xAxis !== undefined && keys.includes(xAxis);
};

export default LineGraph;
